"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    const hasTable = await knex.schema.hasTable(_globals.MetaTable.VIEW_SECTIONS);
    if (!hasTable) {
        await knex.schema.createTable(_globals.MetaTable.VIEW_SECTIONS, (table)=>{
            table.string('id', 20).primary().notNullable();
            table.string('fk_workspace_id', 20);
            table.string('base_id', 20);
            table.string('source_id', 20);
            table.string('fk_model_id', 20).notNullable();
            table.string('title', 255).notNullable();
            table.float('order');
            table.text('meta');
            table.string('created_by', 20);
            table.string('updated_by', 20);
            table.timestamps(true, true);
            table.index([
                'base_id',
                'fk_workspace_id'
            ], 'nc_view_sections_context');
            table.index('fk_model_id', 'nc_view_sections_model_idx');
        });
    }
    const hasColumn = await knex.schema.hasColumn(_globals.MetaTable.VIEWS, 'fk_view_section_id');
    if (!hasColumn) {
        await knex.schema.alterTable(_globals.MetaTable.VIEWS, (table)=>{
            table.string('fk_view_section_id', 20).nullable();
        });
    }
};
const down = async (knex)=>{
    await knex.schema.dropTableIfExists(_globals.MetaTable.VIEW_SECTIONS);
    const hasColumn = await knex.schema.hasColumn(_globals.MetaTable.VIEWS, 'fk_view_section_id');
    if (hasColumn) {
        await knex.schema.alterTable(_globals.MetaTable.VIEWS, (table)=>{
            table.dropColumn('fk_view_section_id');
        });
    }
};
